var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkin-step1"},[_c('div',{staticClass:"checkin-form-wrap clearfix"},[_c('div',{staticClass:"form-wrap"},[_c('checkin-form',{on:{"callback":_vm.checkIn}})],1),(_vm.checkinQRcode)?_c('div',{staticClass:"code-wrap",domProps:{"innerHTML":_vm._s(_vm.checkinQRcode)}}):_vm._e()]),_c('div',{staticClass:"rule-wrap"},[_c('rule')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }